import { render, staticRenderFns } from "./nickname.vue?vue&type=template&id=04a73637&"
import script from "./nickname.vue?vue&type=script&lang=js&"
export * from "./nickname.vue?vue&type=script&lang=js&"
import style0 from "./nickname.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports